export const environment = {
    production: false,
    // baseURl: 'https://localhost:5012/api',
    // imagePath: 'https://localhost:5012/',
    baseURl: 'https://apidev.klinaro.com/api',
    imagePath: 'https://apidev.klinaro.com/',
    newConsultationPanel: true
};
